<template>
  <div class="info-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="教练头像" prop="headImgUrl" style="width:300px;margin-top:30px;">
          <div class="flex change-avater">
            <img :src="form.headImgUrl" alt="" class="user-logo">
            <el-upload ref="uploader" accept="image/*" class="uploader" action="" :show-file-list="false" :on-change="handleUploaderChange" :auto-upload="false">
              <el-button type="text" class="change-avater-button">更换头像</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="教练姓名" prop="name" style="width:300px">
          <el-input v-model="form.name" width="160" />
        </el-form-item>
        <el-form-item label="教练昵称" prop="nickname" style="width:300px">
          <el-input v-model="form.nickname" />
        </el-form-item>
        <el-form-item label="性别" prop="sex" style="width:300px" placeholder="请选择性别">
          <el-select v-model="form.sex">
            <el-option label="未知" :value="0" />
            <el-option label="男" :value="1" />
            <el-option label="女" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="生日" prop="birthDate" style="width:300px">
          <el-date-picker v-model="form.birthDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="手机号" prop="mobile" style="width:300px">
          <el-input v-model="form.mobile" type="number" oninput="if(value.length>11)value=value.slice(0,11)" :disabled="false" />
        </el-form-item>
        <el-form-item label="教练级别" prop="level" style="width:300px">
          <el-select v-model="form.level" placeholder="请选择教练级别">
            <el-option v-for="item in coachLevels" :key="item.id" :label="item.level" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="城市" prop="city" style="width:300px">
          <el-select v-model="form.city" placeholder="请选择城市">
            <el-option v-for="item in cityList" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="合作状态" prop="cooperateStatus" style="width:300px">
          <el-select v-model="form.cooperateStatus" placeholder="请选择合作状态">
            <el-option label="合作中" :value="0" />
            <el-option label="暂停合作" :value="1" />
          </el-select>
        </el-form-item>
        <div class="row-cont">
          <el-form-item label="上衣尺码" prop="dress.coat" style="width:300px">
            <el-select v-model="form.dress.coat" placeholder="请选择合作状态">
              <el-option v-for="item in coatList" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="下衣尺码" prop="dress.underCoat" style="width:300px">
            <el-select v-model="form.dress.underCoat" placeholder="请选择合作状态">
              <el-option v-for="item in shoesList" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="鞋子尺码" prop="dress.shoes" style="width:300px">
            <el-select v-model="form.dress.shoes" placeholder="请选择合作状态">
              <el-option v-for="item in underCoatList" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="加入UA的时间" prop="joinUaTime" style="width:300px">
          <el-date-picker v-model="form.joinUaTime" type="date" format="yyyy/MM/dd" value-format="yyyy-MM-dd" placeholder="选择加入UA的时间" :picker-options="pickerOptions" />
        </el-form-item>
        <el-form-item label="健身工作室" prop="fitnessStudio" style="width:440px">
          <el-input v-model="form.fitnessStudio" />
        </el-form-item>
        <el-form-item label="运动类别" prop="movementTypeSelectVOS" style="width:440px">
          <el-select v-model="form.movementTypeSelectVOS" placeholder="请选择运动类别" multiple>
            <el-option v-for="item in movingSelectVO" :key="item.id" :label="item.tagName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="核心资质" prop="coreQualification" style="width:440px">
          <DragSelect v-model="form.coreQualification" style="width:380px;" multiple placeholder="请选择核心资质">
            <el-option label="ACSM" value="ACSM" />
            <el-option label="NSCA" value="NSCA" />
            <el-option label="ACE" value="ACE" />
            <el-option label="UA认证资质" value="UA认证资质" />
          </DragSelect>
        </el-form-item>
        <el-form-item label="其他资质" prop="otherQualifications" style="width:440px">
          <DragSelect v-model="form.otherQualifications" style="width:380px;" multiple placeholder="请选择其他资质" filterable allow-create default-first-option>
            <el-option label="ONE FIT小团课认证" value="ONE FIT小团课认证" />
            <el-option label="国家武术四段" value="国家武术四段" />
          </DragSelect>
        </el-form-item>
        <el-form-item label="合作方式" prop="modeOfCooperation" style="width:440px">
          <el-select v-model="form.modeOfCooperation" placeholder="请选择合作方式">
            <el-option label="UA签约/UA" :value="0" />
            <el-option label="training/team成员" :value="1" />
            <el-option label="非UA教练" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item style="width:100%;">
          <div class="flex btns">
            <el-button type="info" @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="commitBtn">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
    <Dialog v-if="confirmShow" v-model="confirmShow" :information="confirmContent" @submit-success="confirmSuccess" />
  </div>
</template>
<script>
import { getFileType } from '@/common/js/util';
import Dialog from '@/components/Dialog';
import DragSelect from '@/components/DragSelect';

export default {
  components: { Dialog, DragSelect },
  data() {
    const coatList = ['S', 'M', 'L', 'XL', 'XXL', '3XL'];
    const shoesList = ['S', 'M', 'L', 'XL', 'XXL', '3XL'];
    const underCoatList = [];
    for (let i = 35; i <= 46; i = i + 0.5) {
      underCoatList.push(`${i}`);
    }
    const checkPhone = (rule, value, callback) => { // 手机号验证
      if (!value) {
        callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3456789]\d{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return {
      formDialogShow: false,
      confirmShow: false,
      confirmContent: {
        operation: 'confirm',
        icon: 'warn',
        subTitle: '教练信息将会被更新，是否确认修改教练信息？',
      },
      information: {},
      cancelTxt: '',
      cityList: [],
      form: {
        id: '',
        birthDate: '',
        city: '',
        cooperateStatus: '',
        coreQualification: [],
        headImgUrl: '',
        level: '',
        mobile: '',
        modeOfCooperation: '',
        movementTypeSelectVOS: '',
        name: '',
        nickname: '',
        otherQualifications: [],
        sex: '1',
        dress: {
          coat: '',
          shoes: '',
          underCoat: '',
        },
        joinUaTime: '',
        fitnessStudio: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入教练姓名', trigger: 'blur' },
        ],
        nickname: [
          { required: true, message: '请输入教练昵称', trigger: 'blur' },
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'blur' },
        ],
        birthDate: [
          { required: true, message: '请选择生日', trigger: 'blur' },
        ],
        mobile: [
          { required: true, validator: checkPhone, trigger: 'blur' },
        ],
        level: [
          { required: true, message: '请选择教练级别', trigger: 'blur' },
        ],
        city: [
          { required: true, message: '请选择城市', trigger: 'blur' },
        ],
        cooperateStatus: [
          { required: true, message: '请选择合作状态', trigger: 'blur' },
        ],
        'dress.coat': [
          { required: true, message: '请选择上衣尺码', trigger: 'blur' },
        ],
        'dress.shoes': [
          { required: true, message: '请选择鞋子尺码', trigger: 'blur' },
        ],
        'dress.underCoat': [
          { required: true, message: '请选择下衣尺码', trigger: 'blur' },
        ],
        joinUaTime: [
          { required: true, message: '请选择加入UA的时间', trigger: 'blur' },
        ],
        fitnessStudio: [
          { required: true, message: '请输入健身工作室', trigger: 'blur' },
        ],
        movementTypeSelectVOS: [
          { required: true, message: '请选择运动类别', trigger: 'blur' },
        ],
        modeOfCooperation: [
          { required: true, message: '请选择合作方式', trigger: 'blur' },
        ],
      },
      movingSelectVO: [],
      coatList,
      shoesList,
      underCoatList,
      pickerOptions: {
        disabledDate: (value) => {
          return (new Date(value)).getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    // 教练级别
    coachSelectVO() {
      return this.$store.state.activity.coachSelectVO.reduce((init, item) => {
        if (!init.includes(item.level) && item.level) init.push(item.level);
        return init;
      }, []);
    },
    // 教练级别
    coachLevels() {
      return this.$store.state.activity.coachLevels;
    },
  },
  created() {
    this.getCoachSelect();
  },
  mounted() {
    const query = this.$route.query;
    if (query.id) {
      this.form.id = query.id;
      this.cancelTxt = '编辑';
      this.getCoachDetails();
    }
  },
  methods: {
    getCoachSelect() {
      this.$Api.coach.getCoachSelect().then(res => {
        this.movingSelectVO = res.movingSelectVO || [];
        this.cityList = res.cityNames || [];
      });
    },
    getCoachDetails() {
      this.$Api.coach.getCoachDetails(this.form.id).then(res => {
        if (res.dress === null) {
          res.dress = {
            coat: '',
            shoes: '',
            underCoat: '',
          };
        }
        res.movementTypeSelectVOS = res.movementTypeSelectVOS.reduce((init, item) => {
          init.push(item.id);
          return init;
        }, []);
        this.form = Object.assign(this.form, res);
      });
    },
    // 提交
    commitBtn() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.confirmShow = true;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑
    postEditCoach() {
      const params = Object.assign(this.form);
      this.$Api.coach.postEditCoach(params).then(res => {
        this.$message.success('编辑成功');
        this.$router.go(-1);
      });
    },
    // 二次确认修改弹窗确认回调
    confirmSuccess() {
      this.postEditCoach();
    },
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    handleUploaderChange(file) {
      const raw = file.raw;
      if (getFileType(raw.name) !== 'image') {
        this.$message.error('上传失败，图片格式不符合');
        this.$refs.uploader.clearFiles();
        return;
      }
      this.$Api.uploadFile.uploadImage(raw, 'coach/').then(res => {
        this.uploadLoading = false;
        this.form.headImgUrl = res;
      });
    },
    dialogSuccess() {
      this.$router.go(-1);
    },
  },
};

</script>
<style lang="less" scoped>
.row-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.info-edit {
  .change-avater {
    .user-logo {
      width: 50px;
      height: 50px;
      margin-top: -10px;
      margin-left: 10px;
    }
  }
  .change-avater-button {
    margin-left: 15px;
    color: #0085d0;
  }
  .btns {
    align-items: center;
    justify-content: center;
  }
}
</style>
<style lang="less">
.info-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
}
</style>

